/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import RouterLink from 'app/common/components/singlespa/router-link';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { isNavigating } from 'app/gamma/src/selectors/ui';
import HeaderBrandingLogo from './header-branding-logo';
import styles from './header.less';

interface StateProps {
  brandingLogo: string | undefined;
  brandingName: string | undefined;
  isNavigating: boolean;
}

interface Props extends StateProps {
  className?: string;
  preventDefault?: boolean;
  isLeftAligned?: boolean;
}

class HeaderLogo extends React.Component<Props> {
  render() {
    const { brandingName, brandingLogo, className, isLeftAligned } = this.props;
    const classes = classNames(
      styles.logo,
      className,
      isLeftAligned && styles.narrowScreen,
      this.props.isNavigating && styles.throbbing,
      brandingLogo && !brandingName && styles.branded,
      brandingName && styles.corporateVis,
    );

    return (
      <RouterLink
        href="/"
        className={classes}
        preventDefault={this.props.preventDefault}
      >
        <div className={styles.logoContainer}>
          <HeaderBrandingLogo />
          <span className={styles.loadingLogo} />
          <span className={styles.defaultLogo} />
        </div>
        <div className={styles.brandingName}>{brandingName}</div>
      </RouterLink>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    brandingLogo: state.ui.header.brandingLogo,
    brandingName: state.ui.header.brandingName,
    isNavigating: isNavigating(state),
  };
}

export default connect(mapStateToProps)(HeaderLogo);
